import { axios } from 'lib/axios';

export const loginWithLinkedIn = ({ code }) => {
  return axios.get(`/v2/oauth/linkedin/callback?code=${code}`);
};
